const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question5-container");
const questionElement = document.getElementById("question5");
const answerButtonsElement = document.getElementById("answer-buttons5");
const ctaElement = document.getElementById("cta5");
const imgOne = document.getElementsByClassName("question5-one");
const imgTwo = document.getElementsByClassName("question5-two");
const imgThree = document.getElementsByClassName("question5-three");

const questions5 = [
  {
    question:
      "What is the primary way you communicate with consumers?",
    answers: [
      { text: "Phone", correct: true },
      { text: "Fax", correct: true },
      { text: "Email", correct: true },
      { text: "Other", correct: true },
    ],
  },
  {
    question: "Is texting part of your sales or marketing strategy?",
    answers: [
      { text: "No", correct: true },
      { text: "Sometimes", correct: true },
      { text: "Yes, but it’s inconsistent", correct: true },
    ],
  },
  {
    question: "What do you need help with?",
    answers: [
      { text: "To expand our reach to new leads and prospects", correct: true },
      { text: "To generate engagement among our customers", correct: true },
      { text: "All of the above", correct: true },
    ],
  },
];


let shuffledQuestions5, currentQuestionIndex5;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex5++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions5 = questions5.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex5 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex5 > questions5.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions5[currentQuestionIndex5]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Good news! DYL’s Automated Text Messages can be sent to large groups as part of a larger campaign and can include photos and PDFs, all from your desktop. Click below to find out how.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/group-of-diverse-people-using-phones.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/connected-world-with-technology.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryATM").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

